import { createSlice } from "@reduxjs/toolkit";

let localUser = localStorage?.getItem("google_user");
if (localUser) localUser = JSON.parse(localUser);


const initialState = {
  user: localUser || null,
  token: localStorage?.getItem("google_token") || null,
  isAuthenticated: !!localStorage.getItem("google_token"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isAuthenticated = true;

      localStorage.setItem("google_token", action.payload.token);
      localStorage.setItem("google_user", JSON.stringify(action.payload.user));
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;

      localStorage.removeItem("google_token");
      localStorage.removeItem("google_user");
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export const getAuthState = (state: any) => state?.auth || {};
export default authSlice.reducer;